import {createSelector} from 'reselect';

// Notifications redux state
const notificationsReducerSelector = state => state.notifications;

// Notifications List
const notificationsSelector = createSelector(
    notificationsReducerSelector,
    notificationsReducer => notificationsReducer
);

export {
    notificationsSelector
};